
  export default {
    props: {
      mobile: {
        type: String,
        default: ''
      }
    },
    computed: {
      isCarOrHomeInsurance () {
        return this.$router.currentRoute.fullPath.includes('car-insurance') || this.$router.currentRoute.fullPath.includes('home-insurance');
      },
      isInsuranceMortgage () {
        return this.$router.currentRoute.fullPath.includes('mortgage') || this.$router.currentRoute.fullPath.includes('insurance');
      }
    }
  };
